<template>
  <div class="relative z-index1">
    <div class="absolute bg-faq-dots z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-dots.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly1 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly1.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly2 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly2.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="w-full mx-auto lg:px-12 md:px-12">
      <p
        class="title w-full sm-fsize16 lg:font-medium md:font-medium font-bold"
      >
        FAQ's
      </p>

      <div
        class="
          md:mt-10
          lg:mt-10
          mt-4
          md:py-6
          lg:py-6
          py-4
          md:px-8
          lg:px-8
          px-4
          cust-shadow-FAQ
          rounded-lg
          bg-white
          z-10
        "
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle="'accordion-' + index"
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse
          :id="'accordion-' + index"
          accordion="my-accordion"
          role="tabpanel"
        >
          <p class="subtitle pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faq: [
        {
          id: "01",
          que: "How can I become a companion to a caregiver?",
          answer:
            "The training program for well-wishers aims to equip you with skills and know-how of the challenges in the life of a caregiver, to have the right conversations and provide them the support they always intended to. Register with us for more information.",
        },
        {
          id: "02",
          que: "How can I help my close friend who is a caregiver?",
          answer:
            "You can encourage them to join our community and register with us to get access to exclusive resources that can be helpful for them. You can be a part of their journey by joining the community too.",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
